import toPath from 'lodash.topath';
import cloneDeep from 'lodash.clonedeep';

export const getIn = (obj, key, defaultValue, index = 0) => {
    const path = toPath(key);

    while (obj && index < path.length) {
        obj = obj[path[index++]];
    }

    return obj === undefined ? defaultValue : obj;
};

export const setIn = (obj, path, value) => {
    const res = {};
	const pathArray = toPath(path);
	let currentObject;
    let resVal = res;
    let i = 0;

    for (i = 0; i < pathArray.length; i++) {
        const currentPath = pathArray[i];
        currentObject = getIn(obj, pathArray.slice(0, i + 1));

        if (resVal[currentPath]) {
            resVal = resVal[currentPath];
        } else if (currentObject) {
            resVal = resVal[currentPath] = cloneDeep(currentObject);
        } else {
            const nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    }

    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) {
        return obj;
    }
};

export const isPromise = v => {
    return v && typeof v.then === 'function';
};

export const isDate = date => {
    return date && Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date);
};

export const isFunction = obj => {
    return typeof obj === 'function';
};

export const isObject = obj => {
    return typeof obj === 'object';
};

export const isInteger = obj => {
    return String(Math.floor(obj)) === obj;
};

export const isString = obj => {
    return Object.prototype.toString.call(obj) === '[object String]';
};

export const isNaN = obj => {
    return obj !== obj;
};

export const hasError = obj => {
    if (isString(obj)) {
        return true;
    }

    let i = 0;
    if (isObject(obj)) {
        const keys = Object.keys(obj);
        let prop;
        for (i = 0; i < keys.length; i++) {
            prop = keys[i];
            if (hasError(obj[prop])) {
                return true;
            }
        }
    }

    if (Array.isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            if (hasError(obj[i])) {
                return true;
            }
        }
    }

    return false;
};

export const nextValueFromArray = (arr, index) => {
    const arrLength = arr.length;
    const arrDifferential = Math.floor(index / arrLength);
    let arrPosition = index;

    if (arrDifferential < 1) {
        return arr[index];
    } else {
        arrPosition = index / arrDifferential - arrLength;
        return arr[arrPosition];
    }
};

export const convertArrayToOptionsList = arr => {
	const options = [];

    arr.forEach(row => {
        options.push({ label: row, value: row });
    });

    return options;
};

export const reduceObject = (obj) => Object.keys(obj).reduce(function (r, k) {
	return r.concat(obj[k]);
}, []);
